export const RECRUITER_DETAIL_SET = "RECRUITER_DETAIL_SET"
export const RECRUITER_DETAIL_SET_SUCCESS = "RECRUITER_FORGET_PASSWORD_SUCCESS"
export const RECRUITER_DETAIL_SET_ERROR = "RECRUITER_FORGET_PASSWORD_ERROR"
//get country
export const RECRUITER_DETAIL_GET_COUNTRY = "RECRUITER_DETAIL_GET_COUNTRY"
export const RECRUITER_DETAIL_GET_COUNTRY_SUCCESSFULL = "RECRUITER_DETAIL_GET_COUNTRY_SUCCESSFULL"
export const RECRUITER_DETAIL_GET_COUNTRY_FAILED = "RECRUITER_DETAIL_GET_COUNTRY_FAILED"
//get state
export const RECRUITER_DETAIL_GET_STATE = "RECRUITER_DETAIL_GET_STATE"
export const RECRUITER_DETAIL_GET_STATE_SUCCESSFULL = "RECRUITER_DETAIL_GET_STATE_SUCCESSFULL"
export const RECRUITER_DETAIL_GET_STATE_FAILED = "RECRUITER_DETAIL_GET_STATE_FAILED"
//get ip location
export const RECRUITER_DETAIL_GET_IP_LOCATION = "RECRUITER_DETAIL_GET_IP_LOCATION"
export const RECRUITER_DETAIL_GET_IP_LOCATION_SUCCESSFULL = "RECRUITER_DETAIL_GET_IP_LOCATION_SUCCESSFULL"
export const RECRUITER_DETAIL_GET_IP_LOCATION_FAILED = "RECRUITER_DETAIL_GET_IP_LOCATION_FAILED"
//recruiter profile
export const RECRUITER_EDIT_PROFILE = "RECRUITER_EDIT_PROFILE"
export const RECRUITER_PROFILE_SUCCESS = "RECRUITER_PROFILE_SUCCESS"
export const RECRUITER_PROFILE_ERROR = "RECRUITER_PROFILE_ERROR"
export const RECRUITER_RESET_PROFILE_FLAG = "RECRUITER_RESET_PROFILE_FLAG";
export const RECRUITER_GET_PROFILE_DETAIL ="RECRUITER_GET_PROFILE_DETAIL";
export const RECRUITER_GET_PROFILE_DETAIL_SUCCESS ="RECRUITER_GET_PROFILE_DETAIL_SUCCESS";